import { AxiosError } from "axios";
import * as requests from "../../../requests/templates/requestCreators";
import { EwaThunk } from "../../types";
import * as actions from "../actions";
import { mapApiToDispatch } from "./utils";

let isFetching = false;
const fetchVisibleOverviewTemplatesMetadata =
  (): EwaThunk => async (dispatch, getState) => {
    if (isFetching) return;
    isFetching = true;

    dispatch(actions.requestFetchVisibleOverviewTemplatesMetadata());

    try {
      const response = await requests.fetchVisibleOverviewTemplatesMetadata();
      const visibleTemplatesMetadata = response.data;

      dispatch(
        actions.successFetchVisibleOverviewTemplatesMetadata(
          visibleTemplatesMetadata.map(mapApiToDispatch)
        )
      );
      dispatch(
        actions.setVisibleOverviewTemplateIds(
          visibleTemplatesMetadata.map((template) => template.id)
        )
      );
    } catch (e) {
      dispatch(
        actions.errorFetchVisibleOverviewTemplatesMetadata(
          (e as AxiosError).response
        )
      ); // TODO: nějak to rozparsovat
    } finally {
      isFetching = false;
    }
  };

export default fetchVisibleOverviewTemplatesMetadata;
